<template>
    <section class="py-20 bg-gray-50">
        <div class="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="text-center mb-12">
                <div class="text-4xl font-headings mb-4">Tips and Tricks</div>
                <div class="text-lg text-secondary-600 max-w-2xl mx-auto">
                    Get the most out of {{ title }} with these helpful tips
                </div>
            </div>

            <div class="max-w-4xl mx-auto relative min-h-[120px]">
                <Transition name="tip-fade" mode="out-in">
                    <div :key="currentIndex"
                        class="bg-white rounded-xl p-6 shadow-md border-l-4 border-purple-500 hover:shadow-lg transition-shadow duration-200">
                        <div class="flex gap-4 items-start">
                            <div
                                class="flex-shrink-0 w-10 h-10 rounded-full bg-purple-100 flex items-center justify-center">
                                <LightBulbIcon class="w-6 h-6 text-purple-600" />
                            </div>
                            <div class="flex-1">
                                <div class="text-secondary-700 leading-relaxed">
                                    {{ currentTip }}
                                </div>
                            </div>
                        </div>
                    </div>
                </Transition>
                <div v-if="tips.length > 1" class="flex justify-center gap-2 mt-4">
                    <button v-for="(_, i) in tips" :key="i"
                        type="button"
                        :class="['w-2.5 h-2.5 rounded-full transition-all duration-300', i === currentIndex ? 'bg-purple-500 scale-125' : 'bg-purple-200 hover:bg-purple-300']"
                        :aria-label="`Go to tip ${i + 1}`"
                        @click="currentIndex = i" />
                </div>
            </div>
        </div>
    </section>
</template>
<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue'
import LightBulbIcon from '@heroicons/vue/24/outline/LightBulbIcon'

const props = defineProps({
    title: {
        type: String,
        default: ''
    },
    tips: {
        type: Array,
        default: () => []
    }
})

const currentIndex = ref(0)
const currentTip = computed(() => props.tips[currentIndex.value] ?? '')

let intervalId = null
const ROTATE_MS = 5000

onMounted(() => {
    if (props.tips.length <= 1) return
    intervalId = setInterval(() => {
        currentIndex.value = (currentIndex.value + 1) % props.tips.length
    }, ROTATE_MS)
})

onUnmounted(() => {
    if (intervalId) clearInterval(intervalId)
})
</script>

<style scoped>
.tip-fade-enter-active,
.tip-fade-leave-active {
    transition: opacity 0.4s ease, transform 0.4s ease;
}
.tip-fade-enter-from {
    opacity: 0;
    transform: translateX(12px);
}
.tip-fade-leave-to {
    opacity: 0;
    transform: translateX(-12px);
}
</style>